/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* ZAPIS ZESTAWU W „MOICH KUPONACH” Z KART STATYSTYK (Fala 7, 26.09.2026).
 *
 * Jeden cienki adapter nad JEDNYM magazynem i JEDNYM API:
 * window.PewniakiZestawy (assets/js/moje-zestawy.js, klucz pewniaki:moje-zestawy:v2).
 * Zadnego wlasnego localStorage, zadnej kopii walidacji — reguly gry i zapis
 * robi sklep().dodaj(); zdarzenie `pewniaki:zestawy-zmiana` wysyla magazyn,
 * wiec dolny skrot „Moje kupony” odswieza licznik sam.
 *
 * Trzy miejsca:
 *   [data-mz-zapis-root]  formularz z polami [data-zestaw-liczba] — modul
 *                         „Moj zestaw” na statystykach (7C) i „Zbuduj zestaw
 *                         z liczba X” na profilu liczby (7A). Pole
 *                         [data-mz-stala] nie jest nadpisywane przy dolosowaniu.
 *   [data-ol-zapisz]      „Zapisz wynik jako zestaw” w raporcie ostatniego
 *                         losowania (7B). Wynik, ktory nie jest poprawnym
 *                         kuponem gracza (Multi Multi: 20 liczb, kupon 1-10),
 *                         otwiera formularz panelu z wpisanymi liczbami.
 * Przyciski zapisu sa `hidden` w SSR i odslaniane dopiero, gdy magazyn dziala.
 */
(function (root, doc) {
    'use strict';
    if (!doc || root.PEWNIAKI_ZAPISZ_ZESTAW) { return; }

    function en() { return /^en(?:-|$)/i.test(doc.documentElement.lang || ''); }
    function T(pl, eng) { return en() ? eng : pl; }
    function MZ() { return root.PewniakiZestawy || null; }
    function sklep() { var m = MZ(); try { return m && typeof m.sklep === 'function' ? m.sklep() : null; } catch (e) { return null; } }
    function calkowita(v) { var n = Number(v); return Number.isInteger(n) ? n : NaN; }

    function tekstBledu(b, r) {
        if (b === 'duplikat') { return jst("pages_zapisz_zestaw_js.c7d994d47478"); }
        if (b === 'limit') { return jst("pages_zapisz_zestaw_js.e785182ad22d"); }
        if (b === 'niedostepny') { return jst("pages_zapisz_zestaw_js.c36fd1d16cf5"); }
        if (b === 'miejsce') { return jst("pages_zapisz_zestaw_js.2684e59f40ab"); }
        if (b === 'liczby' || b === 'ile' || b === 'niepoprawny' || b === 'dodatkowe') {
            return r ? jst('zapisz_zestaw.invalid_rules', [r.nazwa, r.pula])
                : jst("pages_zapisz_zestaw_js.1fac7825317c");
        }
        return jst("pages_zapisz_zestaw_js.b0747d87c84b");
    }

    function losowa(max) {
        if (root.crypto && typeof root.crypto.getRandomValues === 'function') {
            var a = new Uint32Array(1), lim = Math.floor(4294967296 / max) * max;
            do { root.crypto.getRandomValues(a); } while (a[0] >= lim);
            return 1 + (a[0] % max);
        }
        return 1 + Math.floor(Math.random() * max);
    }

    /* ── formularz z polami ─────────────────────────────────────────────── */
    function formularz(box) {
        if (box.getAttribute('data-mz-zapis-start') === '1') { return; }
        box.setAttribute('data-mz-zapis-start', '1');
        var gra = box.getAttribute('data-gra') || '', pula = calkowita(box.getAttribute('data-pula'));
        var zrodlo = box.getAttribute('data-mz-zrodlo') || 'analizator';
        var btn = box.querySelector('[data-mz-zapis]'), nazwa = box.querySelector('[data-mz-zapis-nazwa]');
        var status = box.querySelector('[data-mz-zapis-status]'), dolosuj = box.querySelector('[data-mz-dolosuj]');
        var ile = box.querySelector('[data-mz-ile]');
        function komunikat(t, blad) { if (status) { status.textContent = t || ''; status.className = blad ? 'blad-pola' : 'podpowiedz'; } }
        function widoczne() {
            return Array.prototype.filter.call(box.querySelectorAll('[data-zestaw-liczba]'), function (p) {
                var w = p.closest('[data-mz-pole]'); return !(w && w.hidden);
            });
        }
        if (ile) {
            var ustawIle = function () {
                var k = calkowita(ile.value);
                Array.prototype.forEach.call(box.querySelectorAll('[data-mz-pole]'), function (w, i) {
                    var ukryj = i >= k; w.hidden = ukryj;
                    if (ukryj) { var p = w.querySelector('[data-zestaw-liczba]'); if (p && !p.hasAttribute('data-mz-stala')) { p.value = ''; } }
                });
            };
            ile.addEventListener('change', ustawIle);
            ustawIle();
        }
        if (dolosuj) {
            dolosuj.addEventListener('click', function () {
                var pola = widoczne(), zajete = {}, puste = [];
                pola.forEach(function (p) {
                    var n = calkowita(String(p.value).trim());
                    if (String(p.value).trim() !== '' && n >= 1 && n <= pula && !zajete[n]) { zajete[n] = true; }
                    else if (!p.hasAttribute('data-mz-stala')) { p.value = ''; puste.push(p); }
                });
                puste.forEach(function (p) {
                    var n; do { n = losowa(pula); } while (zajete[n]);
                    zajete[n] = true; p.value = String(n);
                });
                komunikat(puste.length ? jst("pages_zapisz_zestaw_js.bca0d53126e6") : jst("pages_zapisz_zestaw_js.8d0ac33ceae2"), false);
            });
        }
        if (btn) {
            btn.addEventListener('click', function () {
                var pola = widoczne(), liczby = [], byla = {};
                for (var i = 0; i < pola.length; i++) {
                    var s = String(pola[i].value).trim();
                    if (s === '') { komunikat(jst('zapisz_zestaw.fill_all', [pola.length]), true); pola[i].focus(); return; }
                    var n = calkowita(s);
                    if (!(n >= 1 && n <= pula) || byla[n]) { komunikat(jst('zapisz_zestaw.unique_range', [pula]), true); pola[i].focus(); return; }
                    byla[n] = true; liczby.push(n);
                }
                var S = sklep();
                if (!S) { komunikat(tekstBledu('gra'), true); return; }
                var r = S.reguly(gra);
                var w = S.dodaj(gra, { liczby: liczby, nazwa: nazwa ? nazwa.value : '' }, zrodlo);
                if (!w.ok) { komunikat(tekstBledu(w.blad, r), true); return; }
                try { S.zdarzenie('my_ticket_save', gra, zrodlo, w.liczba); } catch (e) { /* analityka nie blokuje zapisu */ }
                komunikat(jst('zapisz_zestaw.saved', [w.zestaw.name, w.liczba]), false);
                if (nazwa) { nazwa.value = ''; }
            });
        }
    }

    /* ── zapis wyniku losowania (7B) ────────────────────────────────────── */
    function liczbyZ(atr) { return String(atr || '').split(/\s+/).filter(Boolean).map(calkowita).filter(function (n) { return n >= 1; }); }
    function wynik(btn) {
        if (btn.getAttribute('data-mz-zapis-start') === '1') { return; }
        btn.setAttribute('data-mz-zapis-start', '1');
        var wrap = btn.closest('[data-ol-zapisz-wrap]') || btn.parentNode;
        var status = wrap && wrap.querySelector('[data-ol-zapisz-status]');
        function komunikat(t, blad) { if (status) { status.textContent = t || ''; status.className = blad ? 'blad-pola' : 'podpowiedz'; } }
        btn.addEventListener('click', function () {
            var S = sklep(), gra = btn.getAttribute('data-gra') || '';
            if (!S) { komunikat(tekstBledu('gra'), true); return; }
            var r = S.reguly(gra);
            if (!r) { komunikat(tekstBledu('gra'), true); return; }
            var liczby = liczbyZ(btn.getAttribute('data-liczby')), dod = liczbyZ(btn.getAttribute('data-dodatkowe'));
            var nazwa = jst("pages_zapisz_zestaw_js.1727258aed5c") + (btn.getAttribute('data-data') || '');
            // Kupon gracza: liczba skreslen dozwolona w grze i miesci sie na kuponie.
            var kupon = liczby.length <= r.kupon && r.ile.indexOf(liczby.length) >= 0;
            if (kupon) {
                var dodatkowe = r.dodatkowe && dod.length === r.dodatkowe.ile ? dod : [];
                var w = S.dodaj(gra, { liczby: liczby, dodatkowe: dodatkowe, nazwa: nazwa }, 'wyniki');
                if (!w.ok) { komunikat(tekstBledu(w.blad, r), true); return; }
                try { S.zdarzenie('my_ticket_save', gra, 'wyniki', w.liczba); } catch (e) { /* bez wplywu na zapis */ }
                komunikat(jst('zapisz_zestaw.saved_historical', [w.zestaw.name]), false);
                return;
            }
            var m = MZ(), panel = m && typeof m.panel === 'function' ? m.panel() : null;
            var info = jst('zapisz_zestaw.result_size', [liczby.length, r.nazwa, r.ile[0], r.kupon]);
            if (panel && typeof panel.formularz === 'function') {
                panel.formularz(gra, null, null, { wstepne: { numbers: liczby, extra: [], name: nazwa, info: info }, powrot: btn });
                komunikat(jst("pages_zapisz_zestaw_js.d4853a2389f1"), false);
            } else {
                komunikat(info, true);
            }
        });
    }

    function start() {
        var S = sklep();
        Array.prototype.forEach.call(doc.querySelectorAll('[data-mz-zapis-root]'), function (box) {
            formularz(box);
            Array.prototype.forEach.call(box.querySelectorAll('[data-mz-zapis-wrap]'), function (x) { x.hidden = !S; });
        });
        Array.prototype.forEach.call(doc.querySelectorAll('[data-ol-zapisz]'), function (b) {
            wynik(b);
            var w = b.closest('[data-ol-zapisz-wrap]'); if (w) { w.hidden = !S; }
        });
    }

    root.PEWNIAKI_ZAPISZ_ZESTAW = { start: start };
    if (doc.documentElement.getAttribute('data-mz-gotowe') === '1') { start(); }
    else {
        doc.addEventListener('pewniaki:zestawy-gotowe', start);
        // Strona bez partialu „Moje kupony” nie wysle zdarzenia gotowosci:
        // po zaladowaniu dokumentu uruchamiamy start i ukrywamy przyciski, gdy magazynu brak.
        root.addEventListener('load', function () { if (doc.documentElement.getAttribute('data-mz-gotowe') !== '1') { start(); } });
    }
})(typeof window !== 'undefined' ? window : this, typeof document !== 'undefined' ? document : null);
